import type { ShopperProducts } from '@/scapi';
import type { SerializableEmbeddedComponent } from './embedded-component';
import type { MegaMenuTrendingContent } from './mega-menu-trending';

export const MEGA_MENU_NAVIGATION_RESOURCE = '/resource/mega-menu-navigation';

export type MegaMenuNavigationCategoriesData = {
    brandsCategory: ShopperProducts.schemas['Category'];
    newInCategory: ShopperProducts.schemas['Category'];
    trendingContent: MegaMenuTrendingContent;
};

export type MegaMenuNavigationLoaderData = MegaMenuNavigationCategoriesData & {
    megaMenuEmbedded: SerializableEmbeddedComponent | null;
};

export type { MegaMenuTrendingContent };
